var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.DEFAULT_HELP_LINK = 'https://github.com/bcgov/common-hosted-form-service/wiki';
    Constants.ADV = '';
    return Constants;
}());
export { Constants };
